import { Badge } from '@/components/ui/badge';

export const OUTCOME_STYLE = {
  TP: ['TRUE POSITIVE', 'bg-emerald-100 text-emerald-800'],
  FP: ['FALSE POSITIVE', 'bg-red-100 text-red-800'],
  TN: ['TRUE NEGATIVE', 'bg-slate-100 text-slate-700'],
  FN: ['FALSE NEGATIVE', 'bg-amber-100 text-amber-800'],
  MIXED_DETECTED: ['BLANDAT – VAPE', 'bg-violet-100 text-violet-800'],
  MIXED_NOT_DETECTED: ['BLANDAT – EJ VAPE', 'bg-violet-50 text-violet-700'],
  INSUFFICIENT_DATA: ['OTILLRÄCKLIGA DATA', 'bg-slate-50 text-slate-500'],
  UNLABELED: ['SAKNAR FACIT', 'bg-slate-50 text-slate-500'],
};

export const ALARM_LABEL = {
  new_alarm: 'Nytt larm skapades',
  existing_open_alarm_updated: 'Befintligt öppet larm uppdaterades (ej missad detektion)',
  no_alarm: 'Inget larm',
  unknown: 'Larmstatus okänd',
};

export const FEATURE_LABELS = {
  ratio_pm1_pm25: 'PM1/PM2.5', ratio_pm25_pm10: 'PM2.5/PM10', rise_rate_per_s: 'Ökningstakt (µg/m³/s)',
  time_to_peak_s: 'Tid till max (s)', decay_half_s: 'Avklingning till 50 % (s)', n_peaks: 'Antal toppar', cv: 'Variation (CV)',
  peak_pm1: 'Peak PM1', peak_pm2_5: 'Peak PM2.5', peak_pm10: 'Peak PM10',
};

export function OutcomeBadge({ outcome }) {
  const [label, cls] = OUTCOME_STYLE[outcome] || [outcome, ''];
  return <Badge className={`${cls} text-[10px] font-semibold`} data-testid={`outcome-${outcome}`}>{label}</Badge>;
}
